import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: String,
    toggleClass: { type: String, default: "-is-toggled" },
    text: String,
    textToggled: String,
    icon: String,
    iconToggled: String,
    focus: String,
    dismissable: { type: Boolean, default: false },
  }

  connect() {
    if (this.dismissableValue) {
      this.handleOutsideClick = this.handleOutsideClick.bind(this)
      document.addEventListener("click", this.handleOutsideClick)
    }
  }

  disconnect() {
    if (this.handleOutsideClick) {
      document.removeEventListener("click", this.handleOutsideClick)
    }
  }

  handleOutsideClick(event) {
    const target = document.querySelector(this.targetValue)
    if (!target) return

    // If click is outside both the toggle button and the dropdown, close it
    if (!this.element.contains(event.target) && !target.contains(event.target)) {
      target.classList.remove(this.toggleClassValue)
    }
  }

  toggle() {
    const target = document.querySelector(this.targetValue)
    if (target) {
      target.classList.toggle(this.toggleClassValue)
      if (target.classList.contains("dropdown-inline") && target.classList.contains(this.toggleClassValue)) {
        this.#positionFixed(target)
      }
    }

    if (this.hasIconToggledValue) {
      const use = this.element.querySelector("use")
      if (use) {
        const toggled = use.getAttribute("href") === this.#iconPath(this.iconToggledValue)
        use.setAttribute("href", toggled ? this.#iconPath(this.iconValue) : this.#iconPath(this.iconToggledValue))
      }
    }

    if (this.hasTextToggledValue) {
      const textEl = this.element.querySelector("[data-toggle-text]") || this.element
      const current = textEl.textContent.trim()
      textEl.textContent = current === this.textToggledValue ? this.textValue : this.textToggledValue
    }

    if (this.hasFocusValue) {
      setTimeout(() => document.getElementById(this.focusValue)?.focus(), 50)
    }
  }

  #positionFixed(target) {
    const rect = this.element.getBoundingClientRect()
    target.style.position = "fixed"
    target.style.top = `${rect.bottom}px`
    target.style.right = `${window.innerWidth - rect.right}px`
    target.style.left = "auto"
    target.style.transition = "none"
    target.style.transform = "none"
  }

  #iconPath(name) {
    return `/icons/__remixicon.sprite.svg?v=491#${name}`
  }
}
